// Copyright 2026 Monterosa Productions Limited. All rights reserved.

// Consent storage and listener layer.
// OneTrust (or equivalent) is responsible for collecting user preferences and
// calling saveConsent(). This module persists them and notifies subscribers.

import type { ConsentCategory } from './protocol.js';

export type ConsentPrefs = { analytics: boolean; marketing: boolean };

const STORAGE_KEY = 'proxima-consent';

export function getConsent(): ConsentPrefs | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw) as ConsentPrefs; } catch { return null; }
}

export function saveConsent(prefs: ConsentPrefs): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  for (const cb of changeListeners) cb(prefs);
}

const changeListeners = new Set<(prefs: ConsentPrefs) => void>();

export function onConsentChange(cb: (prefs: ConsentPrefs) => void): () => void {
  changeListeners.add(cb);
  return () => changeListeners.delete(cb);
}

export function toCategories(prefs: ConsentPrefs | null): ConsentCategory[] {
  const cats: ConsentCategory[] = ['functional'];
  if (prefs?.analytics) cats.push('analytics');
  if (prefs?.marketing) cats.push('marketing');
  return cats;
}
